import { defineMessages } from 'react-intl';
import type { NoMessageValues, MessageTag } from 'react-intl';

export const messages = defineMessages<{
  readonly changeLogin: NoMessageValues;
  readonly emailLabel: NoMessageValues;
  readonly emailPlaceholder: NoMessageValues;
  readonly passwordLabel: NoMessageValues;
  readonly passwordPlaceholder: NoMessageValues;
  readonly stayLoggedIn: NoMessageValues;
  readonly login: NoMessageValues;
  readonly customerNoLabel: NoMessageValues;
  readonly customerNoPlaceholder: NoMessageValues;
  readonly dateOfBirthLabel: NoMessageValues;
  readonly dateOfBirthLabelMobile: NoMessageValues;
  readonly changeToCustomerNoLogin: NoMessageValues;
  readonly changeToEmailLogin: NoMessageValues;
  readonly backToBasketButton: NoMessageValues;
  readonly softLoginLogout: { readonly link: MessageTag };
  readonly showPasswordButtonLabelShow: NoMessageValues;
  readonly showPasswordButtonLabelHide: NoMessageValues;
  readonly passwordCounterLabel: NoMessageValues;
  readonly errorInvalidMail: NoMessageValues;
  readonly errorMandatoryField: NoMessageValues;
  readonly errorTooShort: NoMessageValues;
  readonly errorTooLong: NoMessageValues;
  readonly requiredFields: NoMessageValues;
  readonly editEmailAriaLabel: NoMessageValues;
}>({
  changeLogin: {
    id: 'Login.label.change-login',
    defaultMessage: 'Hier klicken und umstellen auf E-Mail-Adresse & Passwort',
  },
  emailLabel: {
    id: 'Login.email.label',
    defaultMessage: 'E-Mail-Adresse *',
  },
  emailPlaceholder: {
    id: 'Login.email.placeholder',
    defaultMessage: 'name@provider.de',
  },
  passwordLabel: {
    id: 'Login.password.label',
    defaultMessage: 'Passwort *',
  },
  passwordPlaceholder: {
    id: 'Login.password.placeholder',
    defaultMessage: '(mind. 6 Zeichen)',
  },
  stayLoggedIn: {
    id: 'Login.label.stay-logged-in',
    defaultMessage: 'Auf diesem Gerät angemeldet bleiben',
  },
  login: {
    id: 'Login.label.login',
    defaultMessage: 'Anmelden',
  },
  customerNoLabel: {
    id: 'Login.customerNo.label',
    defaultMessage: 'Kundennummer',
  },
  customerNoPlaceholder: {
    id: 'Login.customerNo.placeholder',
    defaultMessage: 'Kundennummer',
  },
  dateOfBirthLabel: {
    id: 'Login.dateOfBirth.label',
    defaultMessage: 'Geburtsdatum',
  },
  dateOfBirthLabelMobile: {
    id: 'Login.dateOfBirth.labelMobile',
    defaultMessage: 'Geburtsdatum (TT.MM.JJJJ)',
  },
  changeToCustomerNoLogin: {
    id: 'Login.changeToCustomerNoLogin.text',
    defaultMessage: 'Mit Kundennummer & Geburtsdatum anmelden',
  },
  changeToEmailLogin: {
    id: 'Login.changeToEmailLogin.text',
    defaultMessage: 'Mit E-Mail-Adresse und Passwort anmelden',
  },
  backToBasketButton: {
    id: 'Login.BackToBasketButton.text',
    defaultMessage: 'Zurück zum Warenkorb',
  },
  softLoginLogout: {
    id: 'Login.label.logout',
    defaultMessage: 'Sie können sich auch jederzeit <link>abmelden</link>',
  },
  showPasswordButtonLabelShow: {
    id: 'Login.label.show-password',
    defaultMessage: 'anzeigen',
  },
  showPasswordButtonLabelHide: {
    id: 'Login.label.hide-password',
    defaultMessage: 'ausblenden',
  },
  passwordCounterLabel: {
    id: 'Login.label.password-counter',
    defaultMessage: 'Zeichen',
  },
  errorInvalidMail: {
    id: 'Login.message.invalidMail',
    defaultMessage: 'Die E-Mail-Adresse ist nicht gültig (Format: max-mustermann@firma.de)',
  },
  errorMandatoryField: {
    id: 'PWLogin.message.mandatoryField',
    defaultMessage: 'Das ist ein Pflichtfeld.',
  },
  errorTooShort: {
    id: 'PWLogin.message.tooShort',
    defaultMessage: 'Das Passwort ist zu kurz.',
  },
  errorTooLong: {
    id: 'PWLogin.message.tooLong',
    defaultMessage: 'Das Passwort ist zu lang.',
  },
  requiredFields: {
    id: 'Login.requiredFieldsHint',
    defaultMessage: '* Diese Felder müssen ausgefüllt werden',
  },
  editEmailAriaLabel: {
    id: 'Login.editEmailAriaLabel',
    defaultMessage: 'E-Mail-Adresse ändern',
  },
});
